module.exports = __webpack_public_path__ + "img/close-modal.8f86d928.svg";